import { createTheme } from '@mui/material';

const MUITheme = (lang) => createTheme({
  direction: lang === "en" ? 'ltr' : 'rtl',
  palette: {
    primary: {
      main: '#0090FF',
    },
    text: {
      primary: '#637488',
    },
    error: {
      main: '#E1251B',
    },
  },
  typography: {
    fontFamily: [
      'Circular Std',
      'FS Matthew',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ],
    fontSize: 24,
  },
  components: {
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          fontWeight: 600,
          fontSize: 12,
          lineHeight: '14px',
          marginTop: 5,
          color: '#637488',
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          caretColor: '#0090FF',
          color: '#2a5082',
          fontWeight: 500,
        },
        inputAdornedStart: {
          paddingLeft: '4px !important',
        },
        inputAdornedEnd: {
          paddingRight: '4px !important',
        },
      },
    },
    MuiSlider: {
      styleOverrides: {
        root: {
          padding: '13px 0 23px 0',
        },
        thumb: {
          borderRadius: 14,
          width: 27,
          height: 27,
          background: '#FFF',
          boxShadow: '0 3px 5px 0 #0000001A',
          '&:hover': {
            boxShadow: '0 4px 6px 0 #0000001A',
          },
          '& :focus': {
            //I dunno how that works. But display:none here disables :focus ripple effect
            display: 'none',
          },
        },
        rail: {
          height: 3,
          background: '#E7EBFF',
          width: 'calc(100% + 27px)',
          left: '-13.5px',
        },
        track: {
          border: 'none',
          height: 3,
          background: lang === "en" ? 'linear-gradient(105.18deg, #003DA6 3.44%, #C12638 97.37%)' : 'linear-gradient(105.18deg, #C12638 97.37% 3.44%, #003DA6 97.37%)',
        },
        mark: {
          bottom: 0,
          width: 1,
          height: 9,
          background: '#E7EBFF',
          top: 'unset',
        },
        markLabel: {
          color: '#2A5082',
          fontWeight: 500,
          fontSize: '13px',
          lineHeight: '16px',
          bottom: 0,
          top: 'unset',
          transform: 'translateY(100%) translateX(-50%)',
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        FormHelperTextProps: {
          component: 'div',
        },
      },
    },
  },
});

export default MUITheme;
